// Single DB-driven source of officer title lists (mirrors GET /api/officer-titles).
import { useEffect, useState } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const TITLE_LABELS = {
  Prez: "President", VP: "Vice President", COO: "Chief Operating Officer",
  CTO: "Chief Technology Officer",
  "S@A": "Sergeant at Arms", ENF: "Enforcer", Enf: "Enforcer", SEC: "Secretary",
  CFO: "Chief Financial Officer", CD: "Club Director", CC: "Club Chaplain",
  CCLC: "Club Counselor & Life Coach", MD: "Media Director", PM: "Prospect Manager",
  "(pm)": "Privileged Member", Brother: "Brother", Honorary: "Honorary",
  NPrez: "National President", NVP: "National Vice President",
};

export const DEFAULT_TITLES = {
  all_titles: ["Prez", "VP", "COO", "CTO", "S@A", "ENF", "SEC", "CFO", "CD", "CC", "CCLC", "MD", "PM", "(pm)", "Brother", "Honorary"],
  officer_titles: ["Prez", "VP", "COO", "CTO", "S@A", "Enf", "SEC", "CD", "CFO", "ENF", "PM", "CC", "CMD", "CCLC", "MD", "NVP", "NPrez"],
  national_officer_titles: ["Prez", "VP", "S@A", "ENF", "CD", "CFO", "SEC", "COO", "CTO", "NPrez", "NVP"],
  national_admin_titles: ["Prez", "VP", "CTO", "CFO"],
  leadership_core_titles: ["Prez", "VP", "CTO"],
  promotion_eligible_titles: ["Prez", "VP", "S@A", "ENF", "CFO", "SEC", "COO", "CTO"],
  transcription_titles: ["Prez", "VP", "S@A", "Enf", "ENF", "CTO", "NPrez", "NVP", "NS@A", "NENF", "NSEC"],
  labels: TITLE_LABELS,
  chapter_map: {},
};

let cached = null;
let inflight = null;

export function clearTitlesCache() {
  cached = null;
}

function fetchTitles() {
  if (cached) return Promise.resolve(cached);
  if (!inflight) {
    const token = localStorage.getItem("token");
    inflight = fetch(`${BACKEND_URL}/api/officer-titles`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (data?.lists) {
          cached = {
            ...DEFAULT_TITLES,
            ...data.lists,
            labels: { ...TITLE_LABELS, ...(data.labels || {}) },
            chapter_map: data.chapter_map || {},
          };
        }
        return cached;
      })
      .catch(() => null)
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
}

export function useOfficerTitles() {
  const [titles, setTitles] = useState(cached || DEFAULT_TITLES);
  useEffect(() => {
    let active = true;
    fetchTitles().then((t) => {
      if (active && t) setTitles(t);
    });
    return () => {
      active = false;
    };
  }, []);
  return titles;
}
